import { ELightGalleryType } from '@quesmed/types/models';
import { create } from 'zustand';
import { getAssetMapping, type IAssetSchema } from '@/config';
import type { OmitFunctions } from '@/types';
import { createSelectors } from './selector';

interface AssetState {
  originalAssets: IAssetSchema[];
  assetModal: { title: string; isOpen: boolean; key?: ELightGalleryType; choiceLabel?: string | null };
  assetEditor: { key: ELightGalleryType; choiceLabel?: string | null } | null;
  assetMapping: Record<string, number>;
  setAssetModal: (isOpen: boolean, title: string, key?: ELightGalleryType, choiceLabel?: string) => void;
  closeAssetModal: () => void;
  setAssetEditor: (assetEditor: { key: ELightGalleryType; choiceLabel?: string | null }) => void;
  closeAssetEditor: () => void;
  setAssetMapping: (assets: IAssetSchema[]) => void;
  setOriginalAssets: (assets: IAssetSchema[]) => void;
}

const initialState: OmitFunctions<AssetState> = {
  originalAssets: [],
  assetModal: { title: '', isOpen: false, key: ELightGalleryType.EXPLANATION, choiceLabel: null },
  assetEditor: null,
  assetMapping: {},
};

export const assetState = create<AssetState>()((set) => ({
  ...initialState,
  setOriginalAssets: (assets) => set({ originalAssets: assets }),
  setAssetMapping: (assets) => {
    set({
      // currentRecord: state.currentRecord ? { ...state.currentRecord, assets } : null,
      assetMapping: getAssetMapping(assets),
    });
  },
  setAssetModal: (isOpen, title, key, choiceLabel) =>
    set({
      assetModal: {
        title: title ?? '',
        isOpen,
        key,
        choiceLabel: choiceLabel ?? null,
      },
    }),
  closeAssetModal: () => set({ assetModal: initialState.assetModal }),
  setAssetEditor: (assetEditor) => set({ assetEditor }),
  closeAssetEditor: () => set({ assetEditor: null }),
}));

export const useAssetState = () => assetState((state) => state);
export const useAsset = createSelectors(assetState);
